module.exports = __webpack_public_path__ + "img/usa_flag.76a64ca0.svg";